import React from 'react';
import { format } from 'date-fns';
import { connect } from 'react-redux';

import { SERVER_DATE_FORMAT } from 'constants/logic';
import Segment from 'helpers/segment';
import { selectActiveVenue, selectSchedulesStartDate } from 'selectors/general';
import { selectIsDesktop } from 'selectors/ui';

import { VenueSchedulesContextProvider } from './Contexts/VenueSchedulesContext';
import YieldManagement from './YieldManagement';
import { updateStartDate as updateStartDateAction } from './YieldManagement.saga';

const YieldManagementWithProvider = props => (
  <VenueSchedulesContextProvider>
    <YieldManagement {...props} />
  </VenueSchedulesContextProvider>
);

const mapStateToProps = (state, ownProps) => {
  const { venueId } = selectActiveVenue(state, ownProps);
  const schedulesStartDate = selectSchedulesStartDate(state);
  const isDesktop = selectIsDesktop(state);

  return {
    isDesktop,
    venueId,
    startDate: schedulesStartDate,
    startDateFormatted: format(schedulesStartDate, SERVER_DATE_FORMAT),
  };
};

const mapDispatchToProps = {
  updateStartDateAction,
};

const mergeProps = (stateProps, dispatchProps) => {
  const { venueId } = stateProps;

  return {
    ...stateProps,
    updateStartDate: startDate => {
      Segment.event('Click Date Filter', { venueId });
      dispatchProps.updateStartDateAction(startDate);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(YieldManagementWithProvider);
